export const confirmEmailChange = gql`
    mutation confirmEmailChange(
        $email: String
        $token: String
    ) {
        confirmEmailChange(
            input: {
                email: $email,
                token: $token
            }
        ) {
            status
        }
    }
`
